module.exports = __webpack_public_path__ + "components/rewards/intersport/static/logo-2f406234f37c0f508294fbc80a20a3fd.jpg";